// Keep PMS status slugs unchanged: only Access Doors has a key-delivery step.
export function getBookingStatusLabel(status, serviceType, t) {
  if (serviceType === "messaging" && status?.slug === "checkedin") {
    return t("validStatuses.checkedin");
  }
  return status?.name || "";
}
